<template>
  <div>
    <div
        v-if="role !== null && roles.includes(role)"
        class="sidebar" data-color="green" data-background-color="white" data-image="/images/sidebar-1.jpg">
      <!--
        Tip 1: You can change the color of the sidebar using: data-color="purple | azure | green | orange | danger"

        Tip 2: you can also add an image using data-image tag
    -->
      <div class="logo"><a href="https://lordofhanf.com" class="simple-text logo-normal">
        Lord Of Hanf
      </a></div>
      <div class="sidebar-wrapper">
        <ul class="nav">

          <!--START SEO Manager-->
          <template v-if="role === 'seo_manager'">
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Setting'}">
                <i class="material-icons">settings_suggest</i>

                <p>Setting</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Shop'}">
                <i class="material-icons">shopping_basket</i>

                <p>{{ $t('shop') }}</p>
              </router-link>
            </li>
          </template>
          <!--END SEO Manager-->

          <!--START Order Manager-->
          <template v-else-if="role === 'order_manager'">
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'OrdersList'}">
                <i class="material-icons">move_to_inbox</i>

                <p>{{ $t('orders') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'NewOrder'}">
                <i class="material-icons">store</i>

                <p>KASSA</p>
              </router-link>
            </li>
          </template>
          <!--END Order Manager-->

          <!--START Order Manager-->
          <template v-else-if="role === 'admin' || role === 'manager'">
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Setting'}">
                <i class="material-icons">settings_suggest</i>

                <p>Setting</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'OrdersList'}">
                <i class="material-icons">move_to_inbox</i>

                <p>{{ $t('orders') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'NewOrder'}">
                <i class="material-icons">store</i>

                <p>KASSA</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Shop'}">
                <i class="material-icons">shopping_basket</i>

                <p>{{ $t('shop') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Stock'}">
                <i class="material-icons">storefront</i>

                <p>{{ $t('stockTitle') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Users'}">
                <i class="material-icons">account_circle</i>

                <p>{{ $t('users') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Coupon'}">
                <i class="material-icons">local_offer</i>

                <p>{{ $t('coupons') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Jobs'}">
                <i class="material-icons">work</i>

                <p>{{ $t('jobTitle') }}</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Sliders'}">
                <i class="material-icons">perm_media</i>

                <p>Sliders</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Country'}">
                <i class="material-icons">language</i>

                <p>Countries</p>
              </router-link>
            </li>
            <li class="nav-item" v-if="role === 'admin'">
              <router-link
                  class="nav-link"
                  :to="{name:'Finance'}">
                <i class="material-icons">paid</i>

                <p>Finance</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Dictionary'}">
                <i class="material-icons">book</i>

                <p>Dictionary</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Advertisment'}">
                <i class="material-icons">campaign</i>

                <p>Advertisment</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Gift'}">
                <i class="material-icons">card_giftcard</i>

                <p>Geschenk</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Comments'}">
                <i class="material-icons">comment</i>

                <p>Comments</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Maps'}">
                <i class="material-icons">location_on</i>

                <p>Maps</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Gallery'}">
                <i class="material-icons">perm_media</i>

                <p>Gallery</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'Customers'}">
                <i class="material-icons">supervised_user_circle</i>

                <p>Großhandel</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                  class="nav-link"
                  :to="{name:'ExcelExporter'}">
                <i class="material-icons">supervised_user_circle</i>

                <p>Excel Exporter</p>
              </router-link>
            </li>
          </template>
          <!--END Admin-->

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      role: null,
      roles: ['admin', 'order_manager', 'seo_manager','manager'],
    }
  },
  created() {
    this.role = localStorage.getItem('role');
  }
}
</script>

<style scoped>

</style>